import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';
import { RouterModule } from '@angular/router';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SearchFilterModule } from '../search-filter/search-filter.module';
import { allComponents, allPipes } from './all.exports';

@NgModule({
  declarations: [
    ...allComponents,
    ...allPipes

  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    NgxIntlTelInputModule,
    FormsModule,
    SearchFilterModule
  ],
  exports: [
    ...allComponents,
    ...allPipes,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    CommonModule,
    FormsModule
    
  ]
})
export class GlobalModule {
  static forRoot(): any[] | import("@angular/core").Type<any> | import("@angular/core").ModuleWithProviders<{}> {
    throw new Error('Method not implemented.');
  }
}
